import cx from "clsx"
import { SafeExitButton } from "./SafeExitButton"
import typography from "@rawa/ui/styles/typography.module.css"
import styles from "./SadPage.module.scss"
import { SadLayout } from "./SadLayout"
import { paths } from "../paths"
import SunnyShy from "../assets/sunny-shy.svg?react"
import { ButtonLink } from "./ButtonLink"

type Props = {
  lines: string[]
  kioskMode?: boolean
}

export function SadPage({ lines, kioskMode }: Props) {
  return (
    <SadLayout
      heading={<h1 className={cx(typography.hero, styles.heading)}>Ooops!</h1>}
    >
      <div className={styles.content}>
        <div>
          {lines.map((line) => (
            <p key={line} className={typography.bodyLarge}>
              {line}
            </p>
          ))}
        </div>
        <SunnyShy className={styles.sunnyShy} aria-hidden={true} />
        {kioskMode ? (
          <ButtonLink variant="primary" href={paths.kioskWelcome}>
            Back to home screen
          </ButtonLink>
        ) : (
          <SafeExitButton />
        )}
      </div>
    </SadLayout>
  )
}
